/*
 * fn: slugify
 *
 * Turns an input string into a slug
 *
 */
export const slugify = (input: string) =>
  input
    .replace(/★/g, 'star')
    .replace(/†/g, 'dagger')
    .replace(/Φ/g, 'phi')
    .normalize('NFD')
    .toLowerCase()
    .replace(/[^a-zA-Z0-9-_+\s|/]/g, '')
    .replace(/(^|[\s/])-(?=\d)/g, '$1minus ')
    .replace(/\+/g, 'plus ')
    .replace(/[\s/]+/g, '-')
    .replace(/\|/g, '/')
    .replace(/^-+|-+$/g, '')
